import React from 'react';
import ReactQuill from 'react-quill';
import useCreateJobFacade from '../facades/useCreateJobFacade';

const quillModules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ color: [] }],
    [{ align: [] }],
    ["link", "image"],
  ],
};

const quillFormats = [
  "header", "font", "size", "bold", "italic", "underline",
  "list", "bullet", "align", "link", "image", "color",
];

const CreateJob = () => {
  const { formData, handleChange, handleQuillChange, handleSubmit } = useCreateJobFacade();

  return (
    <div className="bg-[#D9D9D9] container mx-auto mt-10 rounded-lg shadow-md">
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8">
        <h2 className="text-2xl font-bold mb-4 text-center">Create Job Posting</h2>

        <div className="mb-4">
          <label htmlFor="tag" className="block text-gray-700 text-sm font-bold mb-2">Type</label>
          <select
            className="w-full px-3 py-2 border rounded shadow appearance-none text-gray-600"
            name="tag" value={formData.tag} onChange={handleChange}
          >
            <option value="">Select Type</option>
            <option value="Hackathon">Hackathon</option>
            <option value="Job">Job</option>
            <option value="Internship">Internship</option>
            <option value="Job/Internship">Job/Internship</option>
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="title" className="block text-gray-700 text-sm font-bold mb-2">Title</label>
          <input
            type="text" id="title" name="title" value={formData.title} onChange={handleChange}
            className="w-full px-3 py-2 border rounded shadow appearance-none" required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="company" className="block text-gray-700 text-sm font-bold mb-2">Company</label>
          <input
            type="text" id="company" name="company" value={formData.company} onChange={handleChange}
            className="w-full px-3 py-2 border rounded shadow appearance-none" required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="location" className="block text-gray-700 text-sm font-bold mb-2">Location</label>
          <input
            type="text" id="location" name="location" value={formData.location} onChange={handleChange}
            className="w-full px-3 py-2 border rounded shadow appearance-none" required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="description" className="block text-gray-700 text-sm font-bold mb-2">Description</label>
          <ReactQuill
            value={formData.description}
            onChange={handleQuillChange}
            modules={quillModules}
            formats={quillFormats}
            placeholder="Share your Interview experience here"
            theme="snow"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="applyLink" className="block text-gray-700 text-sm font-bold mb-2">Apply Link</label>
          <input
            type="text" id="applyLink" name="applyLink" value={formData.applyLink} onChange={handleChange}
            className="w-full px-3 py-2 border rounded shadow appearance-none" required
          />
        </div>

        <div className="flex items-center justify-center">
          <button
            type="submit"
            className="bg-[#fb8500] hover:bg-[#ffb703] text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Publish
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateJob;
